import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import {
  getCSSColorSVGFill,
  getCSSColorSVGHoverFill,
} from '~/utilities/getCSS';
import type { COLOR } from '~/types/AppData/Theme/ColorInterface';
import type { SocialLinkInterface } from '~/types/AppData/Layout/SocialLinkInterface';
import XIcon from '~/icons/x';

const imgClasses = cva('[&>svg]:h-4', {
  variants: {
    color: getCSSColorSVGFill(),
    hoverColor: getCSSColorSVGHoverFill(),
  },
});

type SocialIconType = {
  icon: SocialLinkInterface;
  color: COLOR;
  hoverColor: COLOR;
};

export default component$<SocialIconType>(
  ({ icon, color, hoverColor }): JSX.Element => {
    if (icon.alt === 'twitter') {
      return (
        <a
          class={imgClasses({ color, hoverColor })}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='X'
          href={icon.url}
        >
          <XIcon />
        </a>
      );
    }

    return (
      <a
        class={imgClasses({ color, hoverColor })}
        target='_blank'
        rel='noopener noreferrer'
        aria-label={icon.alt}
        href={icon.url}
        dangerouslySetInnerHTML={icon.src}
      />
    );
  }
);
